.kdx-card {
	position: relative;
	display: flex;
	z-index: 3;	
	text-decoration: none;
	color: #000;
	@include text-size(14);
	@include line-height(21);
	transform: translateY(0);
	@include transitionDefault(transform);
	flex: 1 0 0%;
	margin: 0 0 $gutter-def;
	height: 100%;
	text-align: left;

	.card-img-top {
		position: relative;
		min-height: 314px;
		border-radius: 0;

		&::before {
			content: '';
			background: $articleHoverImage;
			position: absolute;
			z-index: 2;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			opacity: 0;
			transition: opacity .3s ease-in-out;
		}
		.card-img {
			position: absolute;
			height: 100%;
			width: 100%;
			border-radius: 0;

			background-size: cover;
			background-position: top left;
			background-repeat: no-repeat;
		}
	}
	&.hover {
		.card-img-top {
			&::before { opacity: .5; }
		}
	}
	.tags {
		display: flex;
		align-items: center;
		margin-bottom: 16px;
		width: 100%;			
		overflow: hidden;
		text-overflow: ellipsis;			

		.tag {
			color: #606060;
			@include text-size(12);
			@include line-height(15);
			font-family: $font-family-secondary;
			display: inline-block;
			background: #FFF;
			border-radius: 3px;
			border: 1px solid $articleTagBorder;
			margin-right: 5px;
			padding: 3px;
			text-decoration: none;
			white-space: nowrap;				

			&:nth-child(n+4) { 				
				display: none;
			}
			&:nth-child(3):not(:last-child) {
				position: relative; 				
	
				&::after {
					content: '...';
					position: absolute;
					bottom: 5px;
					left: 100%;
					opacity: 1;
					margin-left: 8px;
					color: #6E6E6E;
					@include text-size(25);					
				}
			}			
			&:last-child { margin-right: 0; }
			&:hover, &:focus {
				background: $articleTagHover;
				border: 1px solid $articleTagHover;
				color: $articleTagHoverText;
			}
		}
	}
	.card-title {						
		@include text-size(18);
		@include line-height(23);
		font-weight: 600;
		position: relative;
		padding-bottom: 8px;
		margin: 0 0 16px 0;
		
		&::after {
			content: '';
			background: $articleHeadingBorder;
			width: 100%;
			max-width: 28px;
			height: 2px;
			position: absolute;
			top: 100%;
			left: 0;
		}		
		a {
			text-decoration: none;

			&:hover, &:focus {
				text-decoration: underline;
				outline: none;
			}
		}
	}
	.date-time-author {
		display: inline-block;
		font-weight: 600;
		@include text-size(14);
		@include line-height(19);			
		margin-bottom: 8px;

		& + .date-time-author {
			border-left: 1px solid #C1C1C1;
			padding-left: 5px;
			margin-left: 5px;
		}	
	}
	.card-body {
		padding: 12px 20px;

		p:last-of-type { padding: 0; }
	}
	.card-footer {
		@include set-bg-color(#FFF);
		border-color: $gray-lite;
		border-radius: 0;
		padding: $gutter-def;

		.btn {
			margin-right: $gutter-sm;

			&:last-child { margin-right: 0; }
		}
		&:last-child { border-radius: 0; }
	}
	&__img-left {
		@extend .kdx-card;
		flex-direction: row;

		.card-img-top {
			display: flex;
			flex: 1 0 45%
		}
		.card-content {
			flex: 1 0 55%;
		}
	}
	&__img-right {
		@extend .kdx-card;
		flex-direction: row-reverse;

		.card-img-top {
			display: flex;
			flex: 1 0 45%
		}
		.card-content {
			flex: 1 0 55%;
		}
	}
	&.kdx-featured-article {
		min-height: 452px;
		justify-content: flex-end;
		
		&::before {
			content: '';
			position: absolute;
			left: 0;
			bottom: 0;
			height: 60%;
			width: 100%;
			z-index: 2;
			/* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#000000+0,000000+100&0+0,1+100 */
			background: -moz-linear-gradient(top,  rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%); /* FF3.6-15 */
			background: -webkit-linear-gradient(top,  rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%); /* Chrome10-25,Safari5.1-6 */
			background: linear-gradient(to bottom,  rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 ); /* IE6-9 */
		}
		&.hover {
			.card-img-top {
				&::before { display: none; }
			}
		}
		.card-img-top {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 1;
		}
		.card-content {
			z-index: 3;
			flex: 0 1 auto;
			color: #FFF;
		}
		.tags {
			.tag {
				&:nth-child(3):not(:last-child) { 
					&::after { color: #FFF; }
				}
			}
		}
		.card-body { padding: 32px; }
		.card-title { 				
			padding-bottom: 0;
			margin: 0 0 8px 0;

			a { color: #FFF; }
			&::after { display: none; }
		}
		.date-time-author { margin-bottom: 16px; }
	}	
}





@include media-breakpoint-down(md) {
	.kdx-card {
		@include text-size(10);
		@include line-height(15);

		.tags {

			.tag {
				@include text-size(10);
				@include line-height(13);
			}
		}
		.card-title {
			@include text-size(12);
			@include line-height(16);
			
			&::after {
				max-width: 28px;
			}
		}
		.date-time-author {
			@include text-size(10);
			@include line-height(14);
		}
		&.kdx-featured-article {
			min-height: 309px;
			@include text-size(10);
			@include line-height(14);

			&::before {
				top: 42%;
			}

			.card-body { padding: 20px; }
		}
	}
}